import { supabase } from './supabase';

/**
 * Récupère toutes les données d'une table Supabase avec pagination automatique
 * pour contourner la limite de max_rows
 */
export async function getAllDataPaginated<T = any>(
  tableName: string,
  selectFields: string = '*',
  batchSize: number = 1000
): Promise<T[]> {
  const allData: T[] = [];
  let from = 0;
  let hasMore = true;
  
  console.log(`Récupération de toutes les données de ${tableName} avec pagination...`);
  
  while (hasMore) {
    const { data, error } = await supabase
      .from(tableName)
      .select(selectFields)
      .range(from, from + batchSize - 1);
    
    if (error) {
      throw error;
    }
    
    if (data && data.length > 0) {
      allData.push(...(data as T[]));
      from += batchSize;
      hasMore = data.length === batchSize; // S'il y a moins de données que la taille du batch, c'est fini
      console.log(`Récupéré ${data.length} éléments, total: ${allData.length}`);
    } else {
      hasMore = false;
    }
  }
  
  console.log(`Récupération terminée: ${allData.length} éléments au total`);
  return allData;
} 